/*
 * @Author: wangshengqiang
 * @Date: 2020-12-18 18:48:34
 * @LastEditTime: 2022-01-09 15:41:42
 * @LastEditors: wangshengqiang
 * @Description:
 */
// 需要持久化到本地存储的数据key值
export const STATE_KEYS_NEED_TO_BE_PERSISTED = ['promotionId', 'templateId', 'orderNo', 'currentPage', 'currentUrl', 'currentPlan', 'PLAN_ID', 'currentPlanInfo', 'trialPrice', 'totalTrialPrice', 'trialExtraFields', 'trialFactors', 'policyHolderFields', 'insurePlanFields', 'fiterLiablities', 'formValues', 'orderPersonDetail', 'trailElementPolicyHolderFields', 'urlParams', 'allTabSelectedModuleList', 'FETCH_STORE', 'orderDetail', 'localCachedState', 'healthNoticeInformation', 'benfitFactorData', 'benefitTable', 'premium'];
export default {
  orderNo: '',
  // 订单号
  currentPage: 1,
  currentPlan: 0,
  // 整个配置数据
  configJson: null,
  // 最大被保险人数
  maxInsurant: 1,
  // warn: 该字段不能持久化存储，因为要参与智能核保那边是否是多被保人判断
  // 最小被保险人数
  minInsurant: 1,
  // 发生改动的表单数据（不包括默认值）
  formValues: {},
  // 产品组合
  packages: null,
  orderDetail: null,
  // 订单详情
  // 字段组件映射关系
  mappings: {},
  // 健告接口内容
  healthNotify: null,
  // 配置流程操作：投保告知预览弹框
  notifyModal: {
    show: false,
    message: ''
  },
  // 配置流程操作：健康高告知预览弹框
  healthModal: {
    type: '',
    // 'refuse' | 'pass'
    text: ''
  },
  resultStatus: 1,
  // 配置流程操作：切换投保结果
  allTabSelectedModuleList: [],
  // 多选瞄点tab切换已选择Module
  supervisionBtnClicked: {
    clicked: false,
    supervisionTarget: null
  },
  // 是否显示 Pdf
  isShowPdfViewer: false,
  // Pdf的url跳转
  pdfUrl: '',
  // 告知与问卷
  questionList: {
    // 投保人告知问卷
    holderList: [],
    // 被保人告知问卷
    insuranceList: [],
    // 代理人告知缓存列表
    agentList: []
  },
  agent: {}
};